// return a span containing a number and a string

const TrendIndicator = ({
  perc_change,
  arrow,
  text = '',
}: {
  perc_change: number
  arrow: string
  text?: string
}) => {
  const prefix = perc_change > 0 ? '+' : ''
  const colors: Dictionary = {
    '↗': '#479260',
    '↘': '#d3343f',
    '→': '#202346',
  }
  let color = '#000'
  if (arrow in colors) {
    color = colors[arrow]
  }
  return (
    <>
      (<span style={{ color: color }}>
        {prefix}
        {perc_change}%
        {/* {arrow} */}
      </span> {text})
    </>
  )
}

export default TrendIndicator
